import React, { useEffect, useRef, useState } from 'react'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'

export default function Calendar({ events = [], onEventCreate, onEventUpdate, onEventDelete }) {
    const [calendarEvents, setCalendarEvents] = useState([]);
    const calendarRef = useRef(null);

    // Convert backend events to FullCalendar format
    useEffect(() => {
        const formattedEvents = events.map(event => ({
            id: event.id.toString(),
            title: event.title,
            start: event.start_date,
            end: event.end_date,
            backgroundColor: event.color || (
                event.event_type === 'task' ? '#10b981' :
                event.priority === 'high' ? '#ef4444' :
                event.priority === 'urgent' ? '#991b1b' :
                event.priority === 'low' ? '#3b82f6' :
                '#f59e0b'
            ),
            borderColor: event.color || (
                event.event_type === 'task' ? '#059669' :
                event.priority === 'high' ? '#dc2626' :
                event.priority === 'urgent' ? '#7f1d1d' :
                event.priority === 'low' ? '#2563eb' :
                '#d97706'
            ),
            extendedProps: {
                event_type: event.event_type,
                priority: event.priority,
                description: event.description,
                progress_percentage: event.progress_percentage,
                task_id: event.task_id
            }
        }));
        setCalendarEvents(formattedEvents);
    }, [events]);

    function handleDateSelect(selectInfo) {
        const title = prompt('Please enter a new title for your event');
        const calendarApi = selectInfo.view.calendar;

        calendarApi.unselect();

        if (title && onEventCreate) {
            const eventData = {
                title,
                start_date: selectInfo.startStr,
                end_date: selectInfo.endStr,
                event_type: 'event',
                priority: 'medium',
                is_all_day: selectInfo.allDay
            };
            onEventCreate(eventData);
        }
    }

    function handleEventClick(clickInfo) {
        const event = clickInfo.event;
        const isTask = event.extendedProps.event_type === 'task';
        
        const message = isTask 
            ? `Are you sure you want to delete the task '${event.title}'?`
            : `Are you sure you want to delete the event '${event.title}'?`;
            
        // eslint-disable-next-line no-restricted-globals
        if (window.confirm(message) && onEventDelete) {
            onEventDelete(event.id);
        }
    }

    function handleEventDrop(dropInfo) {
        if (onEventUpdate) {
            onEventUpdate();
        }
    }

    function renderEventContent(eventInfo) {
        const { event } = eventInfo;
        const isTask = event.extendedProps.event_type === 'task';
        const title = event.title;
        
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: 4, width: '100%', overflow: 'hidden' }}>
                {isTask && (
                    <span style={{ background: '#d1fae5', color: '#059669', fontWeight: 600, fontSize: 11, borderRadius: 4, padding: '2px 8px', marginRight: 4 }}>
                        Task
                    </span>
                )}
                <span style={{ color: '#222', fontSize: 13, fontWeight: 500, textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', maxWidth: 80 }}>{title}</span>
            </div>
        );
    }

    return (
        <div className='demo-app'>
            <div className='demo-app-main'>
                <FullCalendar
                    ref={calendarRef}
                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                    headerToolbar={{
                        left: 'title',
                        center: 'timeGridDay,timeGridWeek,dayGridMonth',
                        right: 'prev,next today'
                    }}
                    buttonText={{
                        today: 'Today',
                        month: 'Month',
                        week: 'Week',
                        day: 'Day'
                    }}
                    initialView='dayGridMonth'
                    editable={true}
                    selectable={true}
                    selectMirror={true}
                    dayMaxEvents={true}
                    weekends={true}
                    events={calendarEvents}
                    select={handleDateSelect}
                    eventContent={renderEventContent}
                    eventClick={handleEventClick}
                    eventDrop={handleEventDrop}
                    height="auto"
                    aspectRatio={1.8}
                />
            </div>
        </div>
    )
}


